import { ClickAwayListener, IconButton, Tooltip } from "@mui/material";
import InfoOutlined from "@mui/icons-material/InfoOutlined";
import { useState } from "react";

export default function WorksheetInfoTooltip({
  label,
  text,
  overridden = false,
}: {
  label: string;
  text: string;
  overridden?: boolean;
}) {
  const [open, setOpen] = useState(false);
  return (
    <ClickAwayListener onClickAway={() => setOpen(false)}>
      <Tooltip
        title={text}
        open={open}
        onOpen={() => setOpen(true)}
        onClose={() => setOpen(false)}
        disableTouchListener
      >
        <IconButton
          size="small"
          aria-label={overridden ? `${label} (manual override)` : label}
          onClick={() => setOpen(true)}
          onFocus={() => setOpen(true)}
          onBlur={() => setOpen(false)}
          onKeyDown={(event) => {
            if (event.key === "Escape") setOpen(false);
          }}
          sx={{ color: overridden ? "warning.main" : "text.secondary", flexShrink: 0 }}
        >
          <InfoOutlined sx={{ fontSize: 16 }} />
        </IconButton>
      </Tooltip>
    </ClickAwayListener>
  );
}
